var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8787 1.70711C12.0503 0.535539 13.9497 0.535535 15.1213 1.70711L17.2929 3.87868C18.4645 5.05026 18.4645 6.94975 17.2929 8.12133L7.29289 18.1213C6.73028 18.6839 5.96722 19 5.17157 19H1C0.447715 19 0 18.5523 0 18V13.8284C0 13.0328 0.316069 12.2697 0.878679 11.7071L10.8787 1.70711ZM13.7071 3.12132C13.3166 2.7308 12.6834 2.7308 12.2929 3.12132L11.4142 4L15 7.58579L15.8787 6.70711C16.2692 6.31659 16.2692 5.68342 15.8787 5.2929L13.7071 3.12132ZM13.5858 9L10 5.41422L4.41421 11L8 14.5858L13.5858 9ZM6.58579 16L3 12.4142L2.29289 13.1213C2.10536 13.3089 2 13.5632 2 13.8284V15.0858L3.91421 17H5.17157C5.43679 17 5.69114 16.8946 5.87868 16.7071L6.58579 16Z",
    fill: "#000A19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.aad5227e59a456ab7a7db8ef0714fa4d.svg";
export { ForwardRef as ReactComponent };